import { FC } from 'react';

import { QrCodeImage } from '@/components';

import { ModalInfo } from '../ModalInfo';

import styles from './QrCodeModal.module.sass';

export interface QrCodeModalProps {
  isActive: boolean;
  url: string;
  title?: string | null;
  onClose: () => void;
}

const QrCodeModal: FC<QrCodeModalProps> = (props) => {
  const { isActive, url, title, onClose } = props;

  return (
    <ModalInfo
      isOpen={isActive}
      title={title}
      className={styles.modal}
      onClose={onClose}
    >
      <div className={styles.content}>
        <div className={styles.qr}>{url && <QrCodeImage address={url} />}</div>
        {url && <div className={styles.url}>{url}</div>}
      </div>
    </ModalInfo>
  );
};

export default QrCodeModal;
